import web from "../web";

class ModesPaiementsService {
    index(token){
        return web.get("/api/modespaiements", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/modespaiements", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/modespaiements/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/modespaiements/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/modespaiements/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ModesPaiementsService()